import React from 'react';
import { Alert, Button, Form } from 'react-bootstrap';
import { PRESETS, isBackwards } from './dateRange';

/**
 * The date range the impact figures cover.
 *
 * The presets are toggle buttons (`aria-pressed`) so the active one is stated
 * and not only shaded. Typing a day makes the range custom. A range that runs
 * backwards is reported and not sent, which the server would refuse anyway.
 */
function RangeControl({ range, preset, onPreset, onChange }) {
    return (
        <fieldset className="mb-4">
            <legend className="h6">Date range</legend>
            <div className="d-flex flex-wrap gap-2 mb-2">
                {PRESETS.map(({ key, label }) => (
                    <Button
                        key={key}
                        size="sm"
                        variant="outline-primary"
                        active={preset === key}
                        aria-pressed={preset === key}
                        onClick={() => onPreset(key)}
                    >
                        {label}
                    </Button>
                ))}
            </div>
            <div className="d-flex flex-wrap gap-3 align-items-end">
                <Form.Group controlId="reports-range-from">
                    <Form.Label className="mb-1">From</Form.Label>
                    <Form.Control
                        type="date"
                        value={range.from}
                        max={range.to || undefined}
                        onChange={(event) =>
                            onChange({ ...range, from: event.target.value })
                        }
                    />
                </Form.Group>
                <Form.Group controlId="reports-range-to">
                    <Form.Label className="mb-1">To</Form.Label>
                    <Form.Control
                        type="date"
                        value={range.to}
                        min={range.from || undefined}
                        onChange={(event) =>
                            onChange({ ...range, to: event.target.value })
                        }
                    />
                </Form.Group>
            </div>
            <p className="text-muted small mt-2 mb-0">
                Leave both blank for all time. The range applies to the impact
                figures, charts, and impact download; the counts at the bottom
                are always all time.
            </p>
            {isBackwards(range) && (
                <Alert variant="warning" className="mt-2 mb-0" role="alert">
                    The start date is after the end date, so the figures below
                    still show the last valid range.
                </Alert>
            )}
        </fieldset>
    );
}

export default RangeControl;
